'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectAttachmentFile = undefined;

var _FileUploadRecord = require('conversations-internal-schema/file-upload/records/FileUploadRecord');

var _FileUploadRecord2 = _interopRequireDefault(_FileUploadRecord);

var _trackInteraction = require('../../usage-tracking/actions/trackInteraction');

var _validationErrorToTrackingFailureType = require('../../file-uploads/util/validationErrorToTrackingFailureType');

var _attachmentError = require('../../file-uploads/actions/attachmentError');

var _identifierForThread = require('../../file-uploads/operators/identifierForThread');

var _validateAttachmentFile = require('../util/validateAttachmentFile');

var _uploadAttachment = require('./uploadAttachment');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectAttachmentFile = exports.selectAttachmentFile = function selectAttachmentFile(_ref) {
  var file = _ref.file,
      thread = _ref.thread;
  return function (dispatch) {
    var threadIdentifier = (0, _identifierForThread.identifierForThread)(thread);

    return (0, _validateAttachmentFile.validateAttachmentFile)(file).then(function () {
      var attachment = new _FileUploadRecord2.default({
        file: file,
        progress: 0
      });

      return dispatch((0, _uploadAttachment.uploadAttachment)({
        attachment: attachment,
        threadId: threadIdentifier
      }));
    }).catch(function (error) {
      dispatch((0, _attachmentError.attachmentError)(error, threadIdentifier));

      dispatch((0, _trackInteraction.trackInteraction)('failed-to-attach-file', {
        action: 'failed to attach file',
        'failure-type': (0, _validationErrorToTrackingFailureType.validationErrorToTrackingFailureType)(error)
      }));
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/actions/selectAttachmentFile.js
// module id = 347
// module chunks = 2 3